var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.propsValue)?_c('span',[_vm._t("default")],2):_c('span',{staticClass:"select-span"},[_vm._v("请选择"+_vm._s(_vm.tip))]),_c('i',{staticClass:"el-icon-edit",on:{"click":_vm.select}}),(_vm.propsValue && _vm.clearable)?_c('i',{staticClass:"el-icon-delete",on:{"click":_vm.clear}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }